import { FEATURE_FLAG_KEYS } from '@alpha-core/feature-flags/feature-flag.constants';
import { Routes } from '@angular/router';
import { FeatureFlagGuard } from '@neutrinos/ngx-feature-flags';
import { environment } from '../environments/environment';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { AdminFiltersComponent } from './components/admin-filters/admin-filters.component';
import { CreateCustomListComponent } from './components/admin-filters/create-custom-list/create-custom-list.component';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { EnquiryComponent } from './components/enquiry/enquiry.component';
import { CreateGroupComponent } from './components/groups/create-group/create-group.component';
import { GroupTableComponent } from './components/groups/group-table/group-table.component';
import { GroupsComponent } from './components/groups/groups.component';
import { InboxComponent } from './components/inbox/inbox.component';
import { CreateUserComponent } from './components/users/create-user/create-user.component';
import { UsersComponent } from './components/users/users.component';
import { AuthGuard } from './guard/auth.guard';
import { branchValidationGuard } from './guard/branch-validation.guard';
import { dashboardGuard } from './guard/dashboard.guard';
import { CasesRedirectResolver } from './shared/resolvers/cases-redirect.resolver';
import { ProjectWithInitResolver } from './shared/resolvers/project.resolver';
export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home/cases',
    },
    {
        path: 'home',
        component: BaseLayoutComponent,
        resolve: {
            project: ProjectWithInitResolver,
        },
        canActivate: [AuthGuard, branchValidationGuard],
        children: [
            {
                path: 'cases',
                pathMatch: 'full',
                resolve: { redirect: CasesRedirectResolver },
                children: [],
            },
            {
                path: 'cases/:inboxType',
                component: InboxComponent,
                data: {
                    menuId: 'cases',
                },
            },
            {
                path: 'groups',
                component: GroupsComponent,
                data: {
                    menuId: 'groups',
                },
                children: [
                    {
                        path: '',
                        component: GroupTableComponent,
                    },
                    {
                        path: 'create',
                        component: CreateGroupComponent,
                    },
                    {
                        path: 'update',
                        component: CreateGroupComponent,
                    },
                ],
            },
            {
                path: 'enquiry',
                component: EnquiryComponent,
                data: {
                    menuId: 'enquiry',
                },
            },
            {
                path: 'users',
                data: {
                    menuId: 'users',
                },
                children: [
                    {
                        path: 'all-users',
                        component: UsersComponent,
                    },
                    {
                        path: 'create-user',
                        component: CreateUserComponent,
                    },
                    {
                        path: 'update-user',
                        component: CreateUserComponent,
                    },
                ],
            },
            {
                path: 'custom-list',
                data: {
                    menuId: 'custom-list',
                    featureFlag: FEATURE_FLAG_KEYS.ADMIN_FILTERS,
                },
                canActivate: [FeatureFlagGuard],
                children: [
                    {
                        path: '',
                        component: AdminFiltersComponent,
                    },
                    {
                        path: 'edit',
                        component: CreateCustomListComponent,
                    },
                    {
                        path: 'edit/:filterId',
                        component: CreateCustomListComponent,
                    },
                ],
            },
            {
                path: 'dashboard',
                data: {
                    menuId: 'dashboard',
                },
                component: AdminDashboardComponent,
                canActivate: [dashboardGuard],
            },
            {
                path: 'reassignment',
                loadComponent: () => import('@alpha-core/platform-ui').then((m) => m.ReassignmentComponent),
                children: [
                    {
                        path: 'before',
                        loadComponent: () =>
                            import('@alpha-core/platform-ui').then((m) => m.BeforeReassignmentSummaryComponent),
                        data: {
                            menuId: '1',
                        },
                    },
                    {
                        path: 'tracker/:operationId',
                        loadComponent: () =>
                            import('@alpha-core/platform-ui').then((m) => m.BulkOperationTrackingComponent),
                        data: {
                            menuId: '3',
                        },
                    },
                ],
            },
            {
                path: 'reassignment/tracker',
                loadComponent: () => import('@alpha-core/platform-ui').then((m) => m.BulkOperationTrackingComponent),
                data: {
                    menuId: '4',
                },
            },
        ],
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('@alpha-core/platform-ui').then((m) => m.UnauthorizedComponent),
        data: {
            backendUrl: environment.ALPHA_UI_ADMIN_SERVICE_URL,
        },
    },

    {
        path: '404',
        loadComponent: () => import('@alpha-core/platform-ui').then((m) => m.NotFoundComponent),
    },
    { path: '**', redirectTo: '404' },
];
